<template>
  <el-dialog
    title="商户信息"
    :visible.sync="dialogVisible"
    customClass="customWidth"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="150px"
      size="small"
    >
      <el-form-item v-if="formEdit2"
        prop="userCode"
        label="登陆名"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.userCode"></el-input>
      </el-form-item>
      <el-form-item
        prop="legal"
        label="姓名"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.legal"></el-input>
      </el-form-item>
      <el-form-item
        prop="userName"
        label="公司/个人"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.userName"></el-input>
      </el-form-item>
      <el-form-item
        prop="mobileNo"
        label="手机"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.mobileNo"></el-input>
      </el-form-item>
      <el-form-item
              prop="wechat_no"
              label="微信号（分账）"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.wechat_no"></el-input>
      </el-form-item>
      <el-form-item
              prop="prov_cd"
              label="省"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.prov_cd"
                placeholder="请选择省"
                @change="currentSel(form.prov_cd)"
        >
          <el-option
                  v-for="item in typeOptions"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="city"
              label="市"
      >
        <el-select
                class="filter-item"
                v-model="form.city"
                placeholder="请选择市"
                @change="currentSel2(form.city)"
        >
          <el-option
                  v-for="item in typeOptions2"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="areaid"
              label="区"
      >
        <el-select
                class="filter-item"
                v-model="form.areaid"
                placeholder="请选择区"
        >
          <el-option
                  v-for="item in typeOptions3"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="compaddress"
              label="地址"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-button type="primary" plain  size="mini"    @click="opendw()">定位</el-button><el-input v-model="form.compaddress" ></el-input>
      </el-form-item>

      <el-form-item
              prop="longitude"
              label="经度"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.longitude" readonly="readonly"></el-input>
      </el-form-item>
      <el-form-item
              prop="latitude"
              label="纬度"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.latitude" readonly="readonly"></el-input>
      </el-form-item>
      <el-form-item
              prop="businessid"
              label="微商城一级分类"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.businessid"
                placeholder="请选择一级分类"
                @change="currentBusinessSel(form.businessid)"
        >
          <el-option
                  v-for="item in businessOptions"
                  :key="item.businessid"
                  :label="item.businessname"
                  :value="item.businessid"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
              prop="businessid_two"
              label="微商城二级分类"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                multiple
                collapse-tags
                class="filter-item"
                v-model="form.businessid_two"
                placeholder="请选择二级分类"
        >
          <el-option
                  v-for="item in businessOptions2"
                  :key="item.two_businessid"
                  :label="item.two_businessname"
                  :value="item.two_businessid"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
              prop="one_type"
              label="经营类别"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.one_type"
                placeholder="请选择一级经营类别"
                @change="currentTypeSel(form.one_type)"
        >
          <el-option
                  v-for="item in shopOptions"
                  :key="item.typeid"
                  :label="item.typename"
                  :value="item.typeid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="two_type"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.two_type"
                placeholder="请选择二级经营类别"
                @change="currentTypeSel2(form.two_type)"
        >
          <el-option
                  v-for="item in shopOptions2"
                  :key="item.typeid"
                  :label="item.typename"
                  :value="item.typeid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="three_type"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.three_type"
                placeholder="请选择三级经营类别"
        >
          <el-option
                  v-for="item in shopOptions3"
                  :key="item.typeid"
                  :label="item.typename"
                  :value="item.typeid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="contractstdate"
              label="合同开始日期"
      >

        <el-date-picker
                v-model="form.contractstdate"
                type="date"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd">
        </el-date-picker>

      </el-form-item>
      <el-form-item
              prop="contractendate"
              label="合同结束日期"
      >
        <el-date-picker
                v-model="form.contractendate"
                type="date"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>

      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>
    <editdw-form
            v-model="editFormVisible2"
            :compaddress2="compaddress2"
            :longitude2="longitude2"
            :latitude2="latitude2"
            @fatherMethod="fatherMethod"
    />
  </el-dialog>

</template>
<style>
  .customWidth{
    width:60%;
  }
</style>
<script>
import * as agentService from '@/api/sys/agent'
import * as userService from '@/api/sys/user'
import * as oneclassService from '@/api/sys/oneclass'
import util from '@/libs/util.js'
import editdwForm from './editdwForm'
export default {
  name: 'shopsEditForm',
  components: { editdwForm },
  props: {
    agent: Object,
    accuseVisible: Boolean,
    value: Boolean
  },
  data () {
    return {
      formEdit: true,
      accuseVisible2: true,
      formEdit2: true,
      loading: false,
      dialogVisible: false,
      editFormVisible2: false,
      pickerOptions: {}, // 日期设置对象
      compaddress2: '',
      longitude2: '',
      latitude2: '',
      form: {
        businessid: '',
        businessid_two: [],
        sort_id: ''
      },
      businessOptions: [],
      businessOptions2: [],
      typeOptions: [],
      typeOptions2: [],
      typeOptions3: [],
      shopOptions: [],
      shopOptions2: [],
      shopOptions3: []
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    accuseVisible (newValue, oldValue) {
      console.log('-----' + newValue)
      this.accuseVisible2 = newValue
    },

    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    dialogOpen () {
      this.$refs.form.resetFields()
      var formData2 = new FormData() // 声明一个FormData对象
      var formData3 = new FormData() // 声明一个FormData对象

      console.log('+++++++++++' + this.accuseVisible2)
      agentService.getProvcd(formData2).then(data => {
        this.typeOptions = data
      })
      agentService.getShopsType(formData3).then(data => {
        this.shopOptions = data
      })

      var formData25 = new FormData() // 声明一个FormData对象
      formData25.append('xt_id', util.cookies.get('xt_id'))
      oneclassService.getOneclass(formData25).then(data => {
        this.businessOptions = data
      })

      if (this.agent.city) {
        this.currentSel(this.agent.prov_cd)
      }
      if (this.agent.areaid) {
        this.currentSel2(this.agent.city)
      }

      if (this.agent.two_type) {
        this.currentTypeSel(this.agent.one_type)
      }
      if (this.agent.three_type) {
        this.currentTypeSel2(this.agent.two_type)
      }
      if (this.agent.businessid_two) {
        this.currentBusinessSel(this.agent.businessid)
      }
      if (this.agent.userId) {
        // userService.getUser(this.user.id).then(data => {
        let form = {}
        form.userCode = this.agent.userCode
        form.legal = this.agent.legal
        form.userName = this.agent.userName
        form.mobileNo = this.agent.mobileNo
        form.wechat_no = this.agent.wechat_no
        form.prov_cd = this.agent.prov_cd
        form.city = this.agent.city
        form.areaid = this.agent.areaid
        form.compaddress = this.agent.compaddress
        form.contractstdate = this.agent.contractstdate
        form.contractendate = this.agent.contractendate
        form.latitude = this.agent.latitude
        form.longitude = this.agent.longitude
        form.one_type = this.agent.one_type
        form.two_type = this.agent.two_type
        form.three_type = this.agent.three_type
        form.businessid = this.agent.businessid
        console.info('&&&&&&&&&&' + this.agent.businessid_two)
        if (this.agent.businessid_two != null && this.agent.businessid_two != '') {
          form.businessid_two = this.agent.businessid_two
        } else {
          form.businessid_two = []
        }
        this.form = form
        // });
        this.formEdit = this.accuseVisible2
        this.formEdit2 = false
      } else {
        this.formEdit = this.accuseVisible2
        this.formEdit2 = true
        this.form = {}
      }
    },
    currentSel (val) {
      if (this.agent.userId) {
        this.form.city = ''
        this.form.areaid = ''
      }
      this.typeOptions2 = []
      var formData2 = new FormData() // 声明一个FormData对象

      formData2.append('type', 'city')
      formData2.append('areaid', val)
      agentService.getProvcd(formData2).then(data => {
        this.typeOptions2 = data
      })
    },
    currentSel2 (val) {
      this.typeOptions3 = []
      var formData2 = new FormData() // 声明一个FormData对象
      formData2.append('type', 'area')
      formData2.append('areaid', val)
      agentService.getProvcd(formData2).then(data => {
        this.typeOptions3 = data
      })
    },
    currentTypeSel (val) {
      if (this.agent.userId) {
        this.form.two_type = ''
        this.form.three_type = ''
      }
      this.shopOptions2 = []
      var formData2 = new FormData() // 声明一个FormData对象

      formData2.append('type', 'twotype')
      formData2.append('typeid', val)
      agentService.getShopsType(formData2).then(data => {
        this.shopOptions2 = data
      })
    },
    currentBusinessSel (val) {
      this.businessOptions2 = []
      var formData2 = new FormData() // 声明一个FormData对象

      formData2.append('businessid', val)
      oneclassService.getTwoclass(formData2).then(data => {
        this.businessOptions2 = data
      })
    },
    currentTypeSel2 (val) {
      this.shopOptions3 = []
      var formData2 = new FormData() // 声明一个FormData对象
      formData2.append('type', 'threetype')
      formData2.append('typeid', val)
      agentService.getShopsType(formData2).then(data => {
        this.shopOptions3 = data
      })
    },
    saveUser () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.agent.userId) {
            this.loading = true
            agentService.saveAgent({ ...this.form, agentid: util.cookies.get('agentid'), id: this.agent.userId, agentids: this.agent.agentid })
              .then(data => {
                if (data != null && data != '') {
                  this.loading = false
                } else {
                  this.loading = false
                  this.dialogVisible = false
                  this.$emit('submit')
                }
              })
          } else {
            userService
              .getCheckUser({ userCode: this.form.userCode })
              .then(data2 => {
                console.log('=========data2:' + data2)
                if (data2 == 'true') {
                  this.loading = true
                  agentService.saveAgent({ ...this.form, agentid: util.cookies.get('agentid'), id: this.agent.userId, agentids: this.agent.agentid, dl_type: '4', xt_id: util.cookies.get('xt_id') })
                    .then(data => {
                      if (data != null && data != '') {
                        this.loading = false
                      } else {
                        this.loading = false
                        this.dialogVisible = false
                        this.$emit('submit')
                      }
                    })
                } else {
                  this.$message('该账号已存在,请更换账号试试')
                }
              })
          }
        } else {
          return false
        }
      })
    },
    fatherMethod (keyword, longitude, latitude) {
      console.log('测试' + keyword)
      this.form.compaddress = keyword
      this.form.longitude = longitude
      this.form.latitude = latitude
    },
    opendw () {
      this.compaddress2 = this.form.compaddress
      if (this.form.latitude != null && this.form.latitude != '') { this.latitude2 = String(this.form.latitude) }
      if (this.form.longitude != null && this.form.longitude != '') { this.longitude2 = String(this.form.longitude) }
      this.editFormVisible2 = true
    },
    close () {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>
